module.exports = __webpack_public_path__ + "img/guide-zh-2.4b1a7ab3.png";